export default __webpack_public_path__ + "static/media/planning.5b612555.svg";